import React from 'react';
import "../../css/calendly.css"
import OnVisible from 'react-on-visible';





class Calendly extends React.Component{  




  constructor(props) {
      
      super(props);
   
   
    }

  handleClasses(){
    var temp ="calendly-wrapper" ;
    this.props.inv && (temp+=" inv");

    if( this.props.bgColor == 'yellow'){
      temp+=" yellow"
    }
    else
    if(  this.props.bgColor == 'deep-blue'){
      temp+=" deep-blue"
    }
    else
    if( this.props.bgColor == 'bright-blue'){
      temp+=" bright-blue"
    }
    
 
return temp
  }

  
render(){ 
  

  
  return (
    <OnVisible className={ this.handleClasses()}>
   
  <div><h3>{this.props.text?this.props.text:"Schedule an Information Call"}</h3></div>
      <div style={{  minWidth:'320px',height:'664px'}}>
      <iframe
        src="https://calendly.com/circadence-sales/discovery-call?embed_domain=www.circadence.com&embed_type=Inline"
        width="100%"
        height="100%"
        frameborder="0"
      ></iframe></div>
        </OnVisible>

  )};
};

export default Calendly;